import React from "react";
import { useParams } from "react-router-dom";
import DataFilters from "../DataFilters/DataFilters";
import Svg from "../Svg/Svg";
import { BizPreview, Container } from "../";

import "./grid.scss";

const Grid = ({ isFetching, bizData }) => {
  let { location } = useParams();
  const niceLocation = location
    ? location.charAt(0).toUpperCase() + location.slice(1)
    : "";

  return (
    <div className="grid">
      <div className="header">
        <h1>Open for business{location ? `: ${niceLocation} area` : ""}</h1>
        <p>
          Find out who is open, when, and the services they are offering.
          <br />
          <strong>
            Note: Updated daily - More business categories will be arriving
            soon!
          </strong>{" "}
          💃
        </p>
      </div>

      {isFetching && (
        <Container style={{ marginBottom: "100px" }}>
          {[0, 0, 0, 0, 0, 0].map((biz, index) => (
            <BizPreview key={index} {...biz} loading={true} />
          ))}
        </Container>
      )}

      {!isFetching && (
        <DataFilters
          bizData={bizData}
          isFetching={isFetching}
          location={location}
        >
          {(filteredData) => (
            <>
              {filteredData.length === 0 && (
                <div
                  style={{
                    textAlign: "center",
                    paddingTop: "100px",
                    paddingBottom: "100px",
                  }}
                >
                  <Svg name="nobusinesses" width={100} height={100} />

                  <h1 className="transparentize">No businesses</h1>
                  <p>
                    Unfortunately no businesses match that search criteria.
                    <br />
                    Please click the <strong>clear filters</strong> button and
                    try again.
                  </p>
                </div>
              )}

              {filteredData.length > 0 && (
                <Container style={{ marginBottom: "100px" }}>
                  {filteredData.map((biz, index) => (
                    <BizPreview key={index} {...biz} lazy={index > 15} />
                  ))}
                </Container>
              )}
            </>
          )}
        </DataFilters>
      )}
    </div>
  );
};

export default Grid;
